import { createContext, ReactNode, useState } from "react"
import { User, Role, Organization } from "../types"

type AuthContextType = {
  user: User | null
  organization: Organization | null
  role: Role | null
  isAuthenticated: boolean
  login: (user: User, organization: Organization, role: Role) => void
  logout: () => void
}

export const AuthContext = createContext<AuthContextType | null>(null)

type AuthProviderProps = {
  children: ReactNode
}

export function AuthProvider({ children }: AuthProviderProps) {
  const [user, setUser] = useState<User | null>(null)
  const [organization, setOrganization] = useState<Organization | null>(null)
  const [role, setRole] = useState<Role | null>(null)

  const login = (userData: User, orgData: Organization, roleData: Role) => {
    setUser(userData)
    setOrganization(orgData)
    setRole(roleData)
  }

  const logout = () => {
    setUser(null)
    setOrganization(null)
    setRole(null)
  }

  const value = {
    user,
    organization,
    role,
    login,
    logout,
    isAuthenticated: !!user,
  }

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>
}
